import { render, staticRenderFns } from "./BannerDetail1.vue?vue&type=template&id=0466bcc5&scoped=true&"
import script from "./BannerDetail1.vue?vue&type=script&lang=js&"
export * from "./BannerDetail1.vue?vue&type=script&lang=js&"
import style0 from "./BannerDetail1.vue?vue&type=style&index=0&id=0466bcc5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466bcc5",
  null
  
)

export default component.exports